<div class="body-padding" id="service-requests-page">
  <div class="flex flex-col items-baseline mb-4">
    <h1 class="general-font text-4xl font-bold text-gray-900" id="service-requests-title">Service Requests</h1>
  </div>
  <div [formGroup]="filterForm" class="flex flex-wrap gap-x-7 gap-y-4 items-baseline align-baseline">
    <div>
      <label for="service-requests-search-input" class="block mb-2 text-sm font-medium text-gray-900">Search</label>
      <div id="service-requests-search-container"
           class="flex items-center h-[36px] border border-gray-300 rounded-md bg-gray-50 dark:bg-gray-700">
        <svg class="ml-2 h-5 w-5 pr-1 text-gray-600" width="15" height="16" viewBox="0 0 15 16" fill="none"
             xmlns="http://www.w3.org/2000/svg">
          <g id="Left Icon">
            <path id="Vector"
                  d="M14.5 15L10.5 11M6.5 13C3.18629 13 0.5 10.3137 0.5 7C0.5 3.68629 3.18629 1 6.5 1C9.81371 1 12.5 3.68629 12.5 7C12.5 10.3137 9.81371 13 6.5 13Z"
                  stroke="#1D1929"/>
          </g>
        </svg>
        <input id="service-requests-search-input" class="input-custom h-full py-0" placeholder="Service Requests Lookup"
               type="text" formControlName="serviceRequestsLookup"/>
      </div>
    </div>
    <div>
      <label for="service-requests-location-select"
             class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
        Location
      </label>
      <ng-select id="service-requests-location-select"
                 [items]="locations"
                 formControlName="location"
                 bindValue="location_id"
                 bindLabel="location_name"
                 placeholder="Location Lookup"
                 [clearable]="isSelectClearable('location')"
                 (clear)="clearSelectValue('location')"
                 notFoundText="No location found">
        <ng-template ng-label-tmp let-item="item">
          <p [id]="'service-requests-location-option-' + item.location_id || 'all'"
             [class.text-gray-500]="item.location_id === 0">
            {{ item.location_name }}
          </p>
        </ng-template>
        <ng-template ng-option-tmp let-item="item">
          <div [id]="'service-requests-location-option-' + item.location_id || 'all'">
            <p>{{ item.location_name }}</p>
            @if (item.full_address) {
              <p class="opacity-50">{{ item.full_address }}</p>
            }
          </div>
        </ng-template>
      </ng-select>
    </div>
    <div>
      <label for="service-requests-status-select"
             class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
        Status
      </label>
      <ng-select id="service-requests-status-select"
                 [items]="statuses"
                 formControlName="status"
                 bindValue="service_request_status_id"
                 bindLabel="service_request_status_name"
                 placeholder="Status Lookup"
                 [clearable]="isSelectClearable('status')"
                 (clear)="clearSelectValue('status')"
                 notFoundText="No status found">
        <ng-template ng-label-tmp let-item="item">
          <div [id]="'service-requests-status-option-' + item.service_request_status_id || 'all'"
               class="flex items-center gap-2">
            @if (item.service_request_status_color) {
              <span class="w-3 h-3 rounded-full" [style.background-color]="item.service_request_status_color"></span>
            }
            <span [class.text-gray-500]="item.service_request_status_id === 0">
              {{ item.service_request_status_name }}
            </span>
          </div>
        </ng-template>
        <ng-template ng-option-tmp let-item="item">
          <div [id]="'service-requests-status-option-' + item.service_request_status_id || 'all'"
               class="flex items-center gap-2">
            @if (item.service_request_status_color) {
              <span class="w-3 h-3 rounded-full" [style.background-color]="item.service_request_status_color"></span>
            }
            <span>{{ item.service_request_status_name }}</span>
          </div>
        </ng-template>
      </ng-select>
    </div>
  </div>
  <ul class="flex gap-2 flex-wrap -mb-px text-lg font-normal text-center pt-4" id="default-tab" role="tablist">
    <li>
      <button id="pending-tab" class="tab-button" [class.selected-tab-button]="tab === 'pending'"
              type="button" role="tab" aria-controls="pending" (click)="changeTab('pending')">
        Pending
      </button>
    </li>
    <li>
      <button id="completed-tab" class="tab-button" [class.selected-tab-button]="tab === 'completed'"
              type="button" role="tab" aria-controls="completed" (click)="changeTab('completed')">
        Completed
      </button>
    </li>
  </ul>
  @if (tab === 'pending') {
    <custom-table id="assets-table" [columns]="tableColumns()" [data]="pendingTableData()"
                  primaryDataKey="ServiceRequestNumber" [actions]="tableActions" [serverPagination]="true"
                  [(currentPage)]="currentPendingTablePage" [loading]="loadingPendingTableData()"
                  (paramsChange)="onPendingTableParamChange($event)"
                  emptyDataMessage="No Service Requests matching your filters"/>
  }
  @if (tab === 'completed') {
    <custom-table id="assets-table" [columns]="tableColumns()" [data]="completedTableData()"
                  primaryDataKey="ServiceRequestNumber" [actions]="tableActions" [serverPagination]="true"
                  [(currentPage)]="currentCompletedTablePage" [loading]="loadingCompletedTableData()"
                  (paramsChange)="onCompletedTableParamChange($event)"
                  emptyDataMessage="No Service Requests matching your filters"/>
  }
</div>
<ng-template #serviceRequestNumberAssetColumn let-row>
  <span class="font-bold">
    {{ row[ServiceRequestsTableColumn.ServiceRequestNumber] }}
  </span>
</ng-template>
<ng-template #assetsColumn let-row>
  @if (row[ServiceRequestsTableColumn.Assets] && row[ServiceRequestsTableColumn.Assets].length > 0) {
    <div class="flex flex-col gap-1">
      @for (asset of getVisibleAssets(row[ServiceRequestsTableColumn.Assets]); track $index) {
        <div class="flex gap-1" [class.text-gray-500]="!asset.isOwned">
          <span>{{ asset.make_name }} {{ asset.model_name }}</span>
          <span class="font-semibold">{{ asset.serial_number }}</span>
          <div class="custom-tooltip-not-owned-2">
            @if (!asset.isOwned) {
              <svg class="w-4 h-4 text-gray-500" aria-hidden="true"
                   xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 20">
                <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                      d="M12 13V8m0 8h.01M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"/>
              </svg>
            }
            <div class="custom-tooltip-text-not-owned-2">
              This Asset has been relocated to another Company.
            </div>
          </div>
        </div>
      }

      @if (row[ServiceRequestsTableColumn.Assets].length > unexpandedAssetsCount && isAssetExpanded(row.id)) {
        @for (asset of getHiddenAssets(row[ServiceRequestsTableColumn.Assets]); track $index) {
          <div class="flex gap-1" [class.text-gray-500]="!asset.isOwned">
            <span>{{ asset.make_name }} {{ asset.model_name }}</span>
            <span class="font-semibold">{{ asset.serial_number }}</span>
            <div class="custom-tooltip-not-owned-2">
              @if (!asset.isOwned) {
                <svg class="w-4 h-4 text-gray-500" aria-hidden="true"
                     xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 20">
                  <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                        d="M12 13V8m0 8h.01M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"/>
                </svg>
              }
              <div class="custom-tooltip-text-not-owned-2">
                This Asset has been relocated to another Company.
              </div>
            </div>
          </div>
        }
      }

      @if (row[ServiceRequestsTableColumn.Assets].length > unexpandedAssetsCount) {
        <div class="text-xs" stopClickPropagation>
          @if (isAssetExpanded(row.id)) {
            <button class="text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-300 underline"
                    type="button" (click)="toggleExpandedAssets(row.id, true)">
              Show less
            </button>
          } @else {
            <button class="text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-300 underline"
                    type="button" (click)="toggleExpandedAssets(row.id, false)">
              (+{{ row[ServiceRequestsTableColumn.Assets].length - unexpandedAssetsCount }} more items)
            </button>
          }
        </div>
      }
    </div>
  }
</ng-template>

@if (isPdfExportRunning) {
  <loading-overlay message="Please wait while we are generating PDF document..."/>
}
